/* eslint-disable */
import UrlPattern from 'url-pattern';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  SearchParams: any;
  JSON: any;
};

export type Node = {
  id: Scalars['ID'];
};

export type JampotImage = {
  __typename?: 'JampotImage';
  src: Scalars['String'];
  dominantColor?: Maybe<Scalars['String']>;
};

export type Region = Node & {
  __typename?: 'Region';
  id: Scalars['ID'];
  name: Scalars['String'];
  name1?: Maybe<Scalars['String']>;
  name2?: Maybe<Scalars['String']>;
  name3?: Maybe<Scalars['String']>;
  name1Id?: Maybe<Region>;
  name2Id?: Maybe<Region>;
  name3Id?: Maybe<Region>;
  depth: Scalars['Int'];
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type FleamarketArticleComment = {
  __typename?: 'FleamarketArticleComment';
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  displayLocationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  userNickname?: Maybe<Scalars['String']>;
  userProfileImage?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<FleamarketArticleComment>>>;
  isDestroyedUser: Scalars['Boolean'];
  isDestroyedComment: Scalars['Boolean'];
  isBlockedComment: Scalars['Boolean'];
  userId?: Maybe<KarrotUser>;
};

export type FleamarketArticleProperty = {
  __typename?: 'FleamarketArticleProperty';
  title: Scalars['String'];
  content: Scalars['String'];
  displayOrder: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type FleamarketArticleH3LocationName = {
  __typename?: 'FleamarketArticleH3LocationName';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const FleamarketArticleStatus = {
  Ongoing: 'Ongoing',
  Reserved: 'Reserved',
  Closed: 'Closed'
} as const;

export type FleamarketArticleStatus = typeof FleamarketArticleStatus[keyof typeof FleamarketArticleStatus];
export type FleamarketArticle = Node & {
  __typename?: 'FleamarketArticle';
  id: Scalars['ID'];
  title: Scalars['String'];
  categoryId?: Maybe<FleamarketCategory>;
  userId?: Maybe<KarrotUser>;
  regionCountryCode: Scalars['String'];
  regionId: Region;
  createdAt: Scalars['String'];
  boostedAt: Scalars['String'];
  images: Array<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  status: FleamarketArticleStatus;
  price?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  favoriteCount: Scalars['Int'];
  chatCount: Scalars['Int'];
  viewCount: Scalars['Int'];
  recommendedArticlesIds: Array<FleamarketArticle>;
  articlePropertyContents: Array<FleamarketArticleProperty>;
  locationName?: Maybe<FleamarketArticleH3LocationName>;
  comments?: Maybe<Array<Maybe<FleamarketArticleComment>>>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type FleamarketCategory = Node & {
  __typename?: 'FleamarketCategory';
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnail: Scalars['String'];
  webIcon?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type KarrotUserReview = {
  __typename?: 'KarrotUserReview';
  userId?: Maybe<KarrotUser>;
  userImage?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  locationName?: Maybe<KarrotUserH3LocationName>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  articleThumbnail?: Maybe<Scalars['String']>;
  isSeller?: Maybe<Scalars['Boolean']>;
};

export type KarrotUserH3LocationName = {
  __typename?: 'KarrotUserH3LocationName';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type KarrotUser = Node & {
  __typename?: 'KarrotUser';
  id: Scalars['ID'];
  nickname: Scalars['String'];
  regionId: Region;
  regionCountryCode: Scalars['String'];
  profileImage: Scalars['String'];
  reviewCount: Scalars['Int'];
  score: Scalars['Int'];
  scoreSymbol: Scalars['String'];
  userArticleIds: Array<FleamarketArticle>;
  receivedReviews: Array<KarrotUserReview>;
  locationName?: Maybe<KarrotUserH3LocationName>;
  isPersonaVerified?: Maybe<Scalars['Boolean']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type HomePageSectionFilter = {
  __typename?: 'HomePageSectionFilter';
  price?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  sortBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};

export type HomePageSection = {
  __typename?: 'HomePageSection';
  header: Scalars['String'];
  position: Scalars['Int'];
  type: Scalars['String'];
  filter?: Maybe<HomePageSectionFilter>;
  articleIds?: Maybe<Array<FleamarketArticle>>;
  categoryIds?: Maybe<Array<FleamarketCategory>>;
};

export type HomePage = Node & {
  __typename?: 'HomePage';
  id: Scalars['ID'];
  sections: Array<HomePageSection>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type AllPage = Node & {
  __typename?: 'AllPage';
  id: Scalars['ID'];
  fleamarketArticles: Array<AllPageFleamarketArticle>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type CategoriesPage = Node & {
  __typename?: 'CategoriesPage';
  id: Scalars['ID'];
  categoryIds: Array<FleamarketCategory>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type AllPageFleamarketArticleComment = {
  __typename?: 'AllPageFleamarketArticleComment';
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['String']>;
  displayLocationName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  userNickname?: Maybe<Scalars['String']>;
  userProfileImage?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<AllPageFleamarketArticleComment>>>;
  isDestroyedUser: Scalars['Boolean'];
  isDestroyedComment: Scalars['Boolean'];
  isBlockedComment: Scalars['Boolean'];
  userId?: Maybe<KarrotUser>;
};

export type AllPageFleamarketArticleProperty = {
  __typename?: 'AllPageFleamarketArticleProperty';
  title: Scalars['String'];
  content: Scalars['String'];
  displayOrder: Scalars['Int'];
  isActive: Scalars['Boolean'];
};

export type AllPageFleamarketArticleH3LocationName = {
  __typename?: 'AllPageFleamarketArticleH3LocationName';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export const AllPageFleamarketArticleStatus = {
  Ongoing: 'Ongoing',
  Reserved: 'Reserved',
  Closed: 'Closed'
} as const;

export type AllPageFleamarketArticleStatus = typeof AllPageFleamarketArticleStatus[keyof typeof AllPageFleamarketArticleStatus];
export type AllPageFleamarketArticle = Node & {
  __typename?: 'AllPageFleamarketArticle';
  id: Scalars['ID'];
  title: Scalars['String'];
  categoryId?: Maybe<FleamarketCategory>;
  userId?: Maybe<Scalars['String']>;
  regionCountryCode: Scalars['String'];
  regionId: Region;
  createdAt: Scalars['String'];
  boostedAt: Scalars['String'];
  images: Array<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  status: AllPageFleamarketArticleStatus;
  price?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  favoriteCount: Scalars['Int'];
  chatCount: Scalars['Int'];
  viewCount: Scalars['Int'];
  recommendedArticlesIds: Array<AllPageFleamarketArticle>;
  articlePropertyContents: Array<AllPageFleamarketArticleProperty>;
  locationName?: Maybe<AllPageFleamarketArticleH3LocationName>;
  comments?: Maybe<Array<Maybe<AllPageFleamarketArticleComment>>>;
  href: Scalars['String'];
  nodeId: Scalars['String'];
  dbId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  ping: Scalars['Boolean'];
  node?: Maybe<Node>;
  region?: Maybe<Region>;
  recentRegions: Array<Region>;
  fleamarketArticle?: Maybe<FleamarketArticle>;
  recentFleamarketArticles: Array<FleamarketArticle>;
  fleamarketCategory?: Maybe<FleamarketCategory>;
  recentFleamarketCategories: Array<FleamarketCategory>;
  karrotUser?: Maybe<KarrotUser>;
  recentKarrotUsers: Array<KarrotUser>;
  homePage: HomePage;
  allPage: AllPage;
  categoriesPage: CategoriesPage;
  allPageFleamarketArticle?: Maybe<AllPageFleamarketArticle>;
  recentAllPageFleamarketArticles: Array<AllPageFleamarketArticle>;
};


export type QueryNodeArgs = {
  nodeId: Scalars['String'];
};


export type QueryRegionArgs = {
  id: Scalars['String'];
};


export type QueryRecentRegionsArgs = {
  size: Scalars['Int'];
};


export type QueryFleamarketArticleArgs = {
  id: Scalars['String'];
};


export type QueryRecentFleamarketArticlesArgs = {
  size: Scalars['Int'];
};


export type QueryFleamarketCategoryArgs = {
  id: Scalars['String'];
};


export type QueryRecentFleamarketCategoriesArgs = {
  size: Scalars['Int'];
};


export type QueryKarrotUserArgs = {
  id: Scalars['String'];
};


export type QueryRecentKarrotUsersArgs = {
  size: Scalars['Int'];
};


export type QueryHomePageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryAllPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryCategoriesPageArgs = {
  additionalSearchParams?: InputMaybe<Scalars['SearchParams']>;
};


export type QueryAllPageFleamarketArticleArgs = {
  id: Scalars['String'];
};


export type QueryRecentAllPageFleamarketArticlesArgs = {
  size: Scalars['Int'];
};

export type Flgsouv4dx19z4lxe91b2aizQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type Flgsouv4dx19z4lxe91b2aizQuery = { __typename?: 'Query', region?: { __typename?: 'Region', id: string, href: string, dbId: string, nodeId: string, name: string, countryCode?: string | null, depth: number } | null };

export type KarrotUserProfileSummary_UserFragment = { __typename?: 'KarrotUser', id: string, dbId: string, href: string, nickname: string, profileImage: string, scoreSymbol: string, score: number, reviewCount: number, isPersonaVerified?: boolean | null, region: { __typename?: 'Region', dbId: string, name: string, countryCode?: string | null }, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null };

export type Fripvga37v2mua02gbe8uqynQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Fripvga37v2mua02gbe8uqynQuery = { __typename?: 'Query', fleamarketArticle?: { __typename?: 'FleamarketArticle', id: string, dbId: string, nodeId: string, href: string, title: string, images: Array<string>, createdAt: string, boostedAt: string, price?: string | null, status: FleamarketArticleStatus, content: string, favoriteCount: number, chatCount: number, viewCount: number, region: { __typename?: 'Region', name: string, dbId: string, nodeId: string, countryCode?: string | null }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, user?: { __typename?: 'KarrotUser', dbId: string, id: string, href: string, nickname: string, profileImage: string, scoreSymbol: string, score: number, reviewCount: number, isPersonaVerified?: boolean | null, userArticles: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, title: string, price?: string | null, thumbnail?: string | null, region: { __typename?: 'Region', name: string, countryCode?: string | null }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null }>, region: { __typename?: 'Region', dbId: string, name: string, countryCode?: string | null }, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null } | null, category?: { __typename?: 'FleamarketCategory', id: string, dbId: string, href: string, name: string, thumbnail: string } | null, recommendedArticles: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, title: string, price?: string | null, thumbnail?: string | null, status: FleamarketArticleStatus, region: { __typename?: 'Region', name: string, countryCode?: string | null }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, category?: { __typename?: 'FleamarketCategory', name: string, thumbnail: string } | null }>, articlePropertyContents: Array<{ __typename?: 'FleamarketArticleProperty', title: string, content: string, displayOrder: number, isActive: boolean }>, comments?: Array<{ __typename?: 'FleamarketArticleComment', id: number, parentId?: number | null, content?: string | null, displayLocationName?: string | null, createdAt?: string | null, userNickname?: string | null, userProfileImage?: string | null, isDestroyedUser: boolean, isDestroyedComment: boolean, isBlockedComment: boolean, userId?: { __typename?: 'KarrotUser', id: string } | null, children?: Array<{ __typename?: 'FleamarketArticleComment', id: number, parentId?: number | null, content?: string | null, displayLocationName?: string | null, createdAt?: string | null, userNickname?: string | null, userProfileImage?: string | null, isDestroyedUser: boolean, isDestroyedComment: boolean, isBlockedComment: boolean, userId?: { __typename?: 'KarrotUser', id: string } | null } | null> | null } | null> | null } | null };

export type Hik5n3ms1203n6p6qpzlqbbbQueryVariables = Exact<{
  nodeId: Scalars['String'];
}>;


export type Hik5n3ms1203n6p6qpzlqbbbQuery = { __typename?: 'Query', karrotUser?: { __typename?: 'KarrotUser', id: string, dbId: string, href: string, nickname: string, profileImage: string, scoreSymbol: string, score: number, reviewCount: number, isPersonaVerified?: boolean | null, region: { __typename?: 'Region', dbId: string, name: string, countryCode?: string | null }, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null, userArticles: Array<{ __typename?: 'FleamarketArticle', id: string, title: string, createdAt: string, boostedAt: string, thumbnail?: string | null, status: FleamarketArticleStatus, price?: string | null, favoriteCount: number, chatCount: number, viewCount: number, category?: { __typename?: 'FleamarketCategory', thumbnail: string, name: string } | null, regionId: { __typename?: 'Region', name: string }, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null }>, receivedReviews: Array<{ __typename?: 'KarrotUserReview', userImage?: string | null, nickname?: string | null, regionName?: string | null, content?: string | null, createdAt?: string | null, articleThumbnail?: string | null, isSeller?: boolean | null, userId?: { __typename?: 'KarrotUser', id: string } | null, locationName?: { __typename?: 'KarrotUserH3LocationName', name?: string | null } | null }> } | null };

export type Oo30o3ofrqgxsncrdx3tl68fQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['String']>;
}>;


export type Oo30o3ofrqgxsncrdx3tl68fQuery = { __typename?: 'Query', homePage: { __typename?: 'HomePage', id: string, regionId?: string | null, regionName?: string | null, sections: Array<{ __typename?: 'HomePageSection', header: string, position: number, type: string, filter?: { __typename?: 'HomePageSectionFilter', regionId?: string | null, categoryId?: string | null, price?: string | null, sortBy?: string | null, search?: string | null } | null, articles?: Array<{ __typename?: 'FleamarketArticle', id: string, href: string, title: string, price?: string | null, thumbnail?: string | null, locationName?: { __typename?: 'FleamarketArticleH3LocationName', name?: string | null } | null, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null, region: { __typename?: 'Region', name: string } }> | null, categories?: Array<{ __typename?: 'FleamarketCategory', id: string, dbId: string, href: string, name: string, webIcon?: string | null }> | null }> } };

export type Erp990xduvwiox2vph5gyi6fQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['String']>;
  h_3_index?: InputMaybe<Scalars['String']>;
  h_3_range_level?: InputMaybe<Scalars['String']>;
  category_id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  only_on_sale?: InputMaybe<Scalars['Boolean']>;
}>;


export type Erp990xduvwiox2vph5gyi6fQuery = { __typename?: 'Query', allPage: { __typename?: 'AllPage', id: string, href: string, fleamarketArticles: Array<{ __typename?: 'AllPageFleamarketArticle', id: string, href: string, price?: string | null, title: string, thumbnail?: string | null, status: AllPageFleamarketArticleStatus, content: string, userId?: string | null, locationName?: { __typename?: 'AllPageFleamarketArticleH3LocationName', name?: string | null } | null, regionId: { __typename?: 'Region', id: string, dbId: string, name: string }, category?: { __typename?: 'FleamarketCategory', thumbnail: string } | null }> } };

export type R94ptrht725sh7n5v7scbcrgQueryVariables = Exact<{ [key: string]: never; }>;


export type R94ptrht725sh7n5v7scbcrgQuery = { __typename?: 'Query', categoriesPage: { __typename?: 'CategoriesPage', fleamarketCategory: Array<{ __typename?: 'FleamarketCategory', id: string, dbId: string, name: string, href: string, webIcon?: string | null }> } };

export type Jn3y9o4zsfq2npf6tcmfa3qnQueryVariables = Exact<{ [key: string]: never; }>;


export type Jn3y9o4zsfq2npf6tcmfa3qnQuery = { __typename?: 'Query', ping0: boolean, ping1: boolean, ping2: boolean, ping3: boolean, ping4: boolean, ping5: boolean, ping6: boolean, ping7: boolean, ping8: boolean, ping9: boolean, ping10: boolean, ping11: boolean, ping12: boolean, ping13: boolean, ping14: boolean, ping15: boolean, ping16: boolean, ping17: boolean, ping18: boolean, ping19: boolean, ping20: boolean, ping21: boolean, ping22: boolean, ping23: boolean, ping24: boolean, ping25: boolean, ping26: boolean, ping27: boolean, ping28: boolean, ping29: boolean, ping30: boolean, ping31: boolean, ping32: boolean, ping33: boolean, ping34: boolean, ping35: boolean, ping36: boolean, ping37: boolean, ping38: boolean, ping39: boolean, ping40: boolean, ping41: boolean, ping42: boolean, ping43: boolean, ping44: boolean, ping45: boolean, ping46: boolean, ping47: boolean, ping48: boolean, ping49: boolean, ping50: boolean, ping51: boolean, ping52: boolean, ping53: boolean, ping54: boolean, ping55: boolean, ping56: boolean, ping57: boolean, ping58: boolean, ping59: boolean, ping60: boolean, ping61: boolean, ping62: boolean, ping63: boolean, ping64: boolean, ping65: boolean, ping66: boolean, ping67: boolean, ping68: boolean, ping69: boolean, ping70: boolean, ping71: boolean, ping72: boolean, ping73: boolean, ping74: boolean, ping75: boolean, ping76: boolean, ping77: boolean, ping78: boolean, ping79: boolean, ping80: boolean, ping81: boolean, ping82: boolean, ping83: boolean, ping84: boolean, ping85: boolean, ping86: boolean, ping87: boolean, ping88: boolean, ping89: boolean, ping90: boolean, ping91: boolean, ping92: boolean, ping93: boolean, ping94: boolean, ping95: boolean, ping96: boolean, ping97: boolean, ping98: boolean, ping99: boolean, ping100: boolean, ping101: boolean, ping102: boolean, ping103: boolean, ping104: boolean, ping105: boolean, ping106: boolean, ping107: boolean, ping108: boolean, ping109: boolean, ping110: boolean, ping111: boolean, ping112: boolean, ping113: boolean, ping114: boolean, ping115: boolean, ping116: boolean, ping117: boolean, ping118: boolean, ping119: boolean, ping120: boolean, ping121: boolean, ping122: boolean, ping123: boolean, ping124: boolean, ping125: boolean, ping126: boolean, ping127: boolean, ping128: boolean, ping129: boolean, ping130: boolean, ping131: boolean, ping132: boolean, ping133: boolean, ping134: boolean, ping135: boolean, ping136: boolean, ping137: boolean, ping138: boolean, ping139: boolean, ping140: boolean, ping141: boolean, ping142: boolean, ping143: boolean, ping144: boolean, ping145: boolean, ping146: boolean, ping147: boolean, ping148: boolean, ping149: boolean, ping150: boolean, ping151: boolean, ping152: boolean, ping153: boolean, ping154: boolean, ping155: boolean, ping156: boolean, ping157: boolean, ping158: boolean, ping159: boolean, ping160: boolean, ping161: boolean, ping162: boolean, ping163: boolean, ping164: boolean, ping165: boolean, ping166: boolean, ping167: boolean, ping168: boolean, ping169: boolean, ping170: boolean, ping171: boolean, ping172: boolean, ping173: boolean, ping174: boolean, ping175: boolean, ping176: boolean, ping177: boolean, ping178: boolean, ping179: boolean, ping180: boolean, ping181: boolean, ping182: boolean, ping183: boolean, ping184: boolean, ping185: boolean, ping186: boolean, ping187: boolean, ping188: boolean, ping189: boolean, ping190: boolean, ping191: boolean, ping192: boolean, ping193: boolean, ping194: boolean, ping195: boolean, ping196: boolean, ping197: boolean, ping198: boolean, ping199: boolean, ping200: boolean, ping201: boolean, ping202: boolean, ping203: boolean, ping204: boolean, ping205: boolean, ping206: boolean, ping207: boolean, ping208: boolean, ping209: boolean, ping210: boolean, ping211: boolean, ping212: boolean, ping213: boolean, ping214: boolean, ping215: boolean, ping216: boolean, ping217: boolean, ping218: boolean, ping219: boolean, ping220: boolean, ping221: boolean, ping222: boolean, ping223: boolean, ping224: boolean, ping225: boolean, ping226: boolean, ping227: boolean, ping228: boolean, ping229: boolean, ping230: boolean, ping231: boolean, ping232: boolean, ping233: boolean, ping234: boolean, ping235: boolean, ping236: boolean, ping237: boolean, ping238: boolean, ping239: boolean, ping240: boolean, ping241: boolean, ping242: boolean, ping243: boolean, ping244: boolean, ping245: boolean, ping246: boolean, ping247: boolean, ping248: boolean, ping249: boolean, ping250: boolean, ping251: boolean, ping252: boolean, ping253: boolean, ping254: boolean, ping255: boolean, ping256: boolean, ping257: boolean, ping258: boolean, ping259: boolean, ping260: boolean, ping261: boolean, ping262: boolean, ping263: boolean, ping264: boolean, ping265: boolean, ping266: boolean, ping267: boolean, ping268: boolean, ping269: boolean, ping270: boolean, ping271: boolean, ping272: boolean, ping273: boolean, ping274: boolean, ping275: boolean, ping276: boolean, ping277: boolean, ping278: boolean, ping279: boolean, ping280: boolean, ping281: boolean, ping282: boolean, ping283: boolean, ping284: boolean, ping285: boolean, ping286: boolean, ping287: boolean, ping288: boolean, ping289: boolean, ping290: boolean, ping291: boolean, ping292: boolean, ping293: boolean, ping294: boolean, ping295: boolean, ping296: boolean, ping297: boolean, ping298: boolean, ping299: boolean, ping300: boolean, ping301: boolean, ping302: boolean, ping303: boolean, ping304: boolean, ping305: boolean, ping306: boolean, ping307: boolean, ping308: boolean, ping309: boolean, ping310: boolean, ping311: boolean, ping312: boolean, ping313: boolean, ping314: boolean, ping315: boolean, ping316: boolean, ping317: boolean, ping318: boolean, ping319: boolean, ping320: boolean, ping321: boolean, ping322: boolean, ping323: boolean, ping324: boolean, ping325: boolean, ping326: boolean, ping327: boolean, ping328: boolean, ping329: boolean, ping330: boolean, ping331: boolean, ping332: boolean, ping333: boolean, ping334: boolean, ping335: boolean, ping336: boolean, ping337: boolean, ping338: boolean, ping339: boolean, ping340: boolean, ping341: boolean, ping342: boolean, ping343: boolean, ping344: boolean, ping345: boolean, ping346: boolean, ping347: boolean, ping348: boolean, ping349: boolean, ping350: boolean, ping351: boolean, ping352: boolean, ping353: boolean, ping354: boolean, ping355: boolean, ping356: boolean, ping357: boolean, ping358: boolean, ping359: boolean, ping360: boolean, ping361: boolean, ping362: boolean, ping363: boolean, ping364: boolean, ping365: boolean, ping366: boolean, ping367: boolean, ping368: boolean, ping369: boolean, ping370: boolean, ping371: boolean, ping372: boolean, ping373: boolean, ping374: boolean, ping375: boolean, ping376: boolean, ping377: boolean, ping378: boolean, ping379: boolean, ping380: boolean, ping381: boolean, ping382: boolean, ping383: boolean, ping384: boolean, ping385: boolean, ping386: boolean, ping387: boolean, ping388: boolean, ping389: boolean, ping390: boolean, ping391: boolean, ping392: boolean, ping393: boolean, ping394: boolean, ping395: boolean, ping396: boolean, ping397: boolean, ping398: boolean, ping399: boolean, ping400: boolean, ping401: boolean, ping402: boolean, ping403: boolean, ping404: boolean, ping405: boolean, ping406: boolean, ping407: boolean, ping408: boolean, ping409: boolean, ping410: boolean, ping411: boolean, ping412: boolean, ping413: boolean, ping414: boolean, ping415: boolean, ping416: boolean, ping417: boolean, ping418: boolean, ping419: boolean, ping420: boolean, ping421: boolean, ping422: boolean, ping423: boolean, ping424: boolean, ping425: boolean, ping426: boolean, ping427: boolean, ping428: boolean, ping429: boolean, ping430: boolean, ping431: boolean, ping432: boolean, ping433: boolean, ping434: boolean, ping435: boolean, ping436: boolean, ping437: boolean, ping438: boolean, ping439: boolean, ping440: boolean, ping441: boolean, ping442: boolean, ping443: boolean, ping444: boolean, ping445: boolean, ping446: boolean, ping447: boolean, ping448: boolean, ping449: boolean, ping450: boolean, ping451: boolean, ping452: boolean, ping453: boolean, ping454: boolean, ping455: boolean, ping456: boolean, ping457: boolean, ping458: boolean, ping459: boolean, ping460: boolean, ping461: boolean, ping462: boolean, ping463: boolean, ping464: boolean, ping465: boolean, ping466: boolean, ping467: boolean, ping468: boolean, ping469: boolean, ping470: boolean, ping471: boolean, ping472: boolean, ping473: boolean, ping474: boolean, ping475: boolean, ping476: boolean, ping477: boolean, ping478: boolean, ping479: boolean, ping480: boolean, ping481: boolean, ping482: boolean, ping483: boolean, ping484: boolean, ping485: boolean, ping486: boolean, ping487: boolean, ping488: boolean, ping489: boolean, ping490: boolean, ping491: boolean, ping492: boolean, ping493: boolean, ping494: boolean, ping495: boolean, ping496: boolean, ping497: boolean, ping498: boolean, ping499: boolean, ping500: boolean, ping501: boolean, ping502: boolean, ping503: boolean, ping504: boolean, ping505: boolean, ping506: boolean, ping507: boolean, ping508: boolean, ping509: boolean, ping510: boolean, ping511: boolean, ping512: boolean, ping513: boolean, ping514: boolean, ping515: boolean, ping516: boolean, ping517: boolean, ping518: boolean, ping519: boolean, ping520: boolean, ping521: boolean, ping522: boolean, ping523: boolean, ping524: boolean, ping525: boolean, ping526: boolean, ping527: boolean, ping528: boolean, ping529: boolean, ping530: boolean, ping531: boolean, ping532: boolean, ping533: boolean, ping534: boolean, ping535: boolean, ping536: boolean, ping537: boolean, ping538: boolean, ping539: boolean, ping540: boolean, ping541: boolean, ping542: boolean, ping543: boolean, ping544: boolean, ping545: boolean, ping546: boolean, ping547: boolean, ping548: boolean, ping549: boolean, ping550: boolean, ping551: boolean, ping552: boolean, ping553: boolean, ping554: boolean, ping555: boolean, ping556: boolean, ping557: boolean, ping558: boolean, ping559: boolean, ping560: boolean, ping561: boolean, ping562: boolean, ping563: boolean, ping564: boolean, ping565: boolean, ping566: boolean, ping567: boolean, ping568: boolean, ping569: boolean, ping570: boolean, ping571: boolean, ping572: boolean, ping573: boolean, ping574: boolean, ping575: boolean, ping576: boolean, ping577: boolean, ping578: boolean, ping579: boolean, ping580: boolean, ping581: boolean, ping582: boolean, ping583: boolean, ping584: boolean, ping585: boolean, ping586: boolean, ping587: boolean, ping588: boolean, ping589: boolean, ping590: boolean, ping591: boolean, ping592: boolean, ping593: boolean, ping594: boolean, ping595: boolean, ping596: boolean, ping597: boolean, ping598: boolean, ping599: boolean, ping600: boolean, ping601: boolean, ping602: boolean, ping603: boolean, ping604: boolean, ping605: boolean, ping606: boolean, ping607: boolean, ping608: boolean, ping609: boolean, ping610: boolean, ping611: boolean, ping612: boolean, ping613: boolean, ping614: boolean, ping615: boolean, ping616: boolean, ping617: boolean, ping618: boolean, ping619: boolean, ping620: boolean, ping621: boolean, ping622: boolean, ping623: boolean, ping624: boolean, ping625: boolean, ping626: boolean, ping627: boolean, ping628: boolean, ping629: boolean, ping630: boolean, ping631: boolean, ping632: boolean, ping633: boolean, ping634: boolean, ping635: boolean, ping636: boolean, ping637: boolean, ping638: boolean, ping639: boolean, ping640: boolean, ping641: boolean, ping642: boolean, ping643: boolean, ping644: boolean, ping645: boolean, ping646: boolean, ping647: boolean, ping648: boolean, ping649: boolean, ping650: boolean, ping651: boolean, ping652: boolean, ping653: boolean, ping654: boolean, ping655: boolean, ping656: boolean, ping657: boolean, ping658: boolean, ping659: boolean, ping660: boolean, ping661: boolean, ping662: boolean, ping663: boolean, ping664: boolean, ping665: boolean, ping666: boolean, ping667: boolean, ping668: boolean, ping669: boolean, ping670: boolean, ping671: boolean, ping672: boolean, ping673: boolean, ping674: boolean, ping675: boolean, ping676: boolean, ping677: boolean, ping678: boolean, ping679: boolean, ping680: boolean, ping681: boolean, ping682: boolean, ping683: boolean, ping684: boolean, ping685: boolean, ping686: boolean, ping687: boolean, ping688: boolean, ping689: boolean, ping690: boolean, ping691: boolean, ping692: boolean, ping693: boolean, ping694: boolean, ping695: boolean, ping696: boolean, ping697: boolean, ping698: boolean, ping699: boolean, ping700: boolean, ping701: boolean, ping702: boolean, ping703: boolean, ping704: boolean, ping705: boolean, ping706: boolean, ping707: boolean, ping708: boolean, ping709: boolean, ping710: boolean, ping711: boolean, ping712: boolean, ping713: boolean, ping714: boolean, ping715: boolean, ping716: boolean, ping717: boolean, ping718: boolean, ping719: boolean, ping720: boolean, ping721: boolean, ping722: boolean, ping723: boolean, ping724: boolean, ping725: boolean, ping726: boolean, ping727: boolean, ping728: boolean, ping729: boolean, ping730: boolean, ping731: boolean, ping732: boolean, ping733: boolean, ping734: boolean, ping735: boolean, ping736: boolean, ping737: boolean, ping738: boolean, ping739: boolean, ping740: boolean, ping741: boolean, ping742: boolean, ping743: boolean, ping744: boolean, ping745: boolean, ping746: boolean, ping747: boolean, ping748: boolean, ping749: boolean, ping750: boolean, ping751: boolean, ping752: boolean, ping753: boolean, ping754: boolean, ping755: boolean, ping756: boolean, ping757: boolean, ping758: boolean, ping759: boolean, ping760: boolean, ping761: boolean, ping762: boolean, ping763: boolean, ping764: boolean, ping765: boolean, ping766: boolean, ping767: boolean, ping768: boolean, ping769: boolean, ping770: boolean, ping771: boolean, ping772: boolean, ping773: boolean, ping774: boolean, ping775: boolean, ping776: boolean, ping777: boolean, ping778: boolean, ping779: boolean, ping780: boolean, ping781: boolean, ping782: boolean, ping783: boolean, ping784: boolean, ping785: boolean, ping786: boolean, ping787: boolean, ping788: boolean, ping789: boolean, ping790: boolean, ping791: boolean, ping792: boolean, ping793: boolean, ping794: boolean, ping795: boolean, ping796: boolean, ping797: boolean, ping798: boolean, ping799: boolean, ping800: boolean, ping801: boolean, ping802: boolean, ping803: boolean, ping804: boolean, ping805: boolean, ping806: boolean, ping807: boolean, ping808: boolean, ping809: boolean, ping810: boolean, ping811: boolean, ping812: boolean, ping813: boolean, ping814: boolean, ping815: boolean, ping816: boolean, ping817: boolean, ping818: boolean, ping819: boolean, ping820: boolean, ping821: boolean, ping822: boolean, ping823: boolean, ping824: boolean, ping825: boolean, ping826: boolean, ping827: boolean, ping828: boolean, ping829: boolean, ping830: boolean, ping831: boolean, ping832: boolean, ping833: boolean, ping834: boolean, ping835: boolean, ping836: boolean, ping837: boolean, ping838: boolean, ping839: boolean, ping840: boolean, ping841: boolean, ping842: boolean, ping843: boolean, ping844: boolean, ping845: boolean, ping846: boolean, ping847: boolean, ping848: boolean, ping849: boolean, ping850: boolean, ping851: boolean, ping852: boolean, ping853: boolean, ping854: boolean, ping855: boolean, ping856: boolean, ping857: boolean, ping858: boolean, ping859: boolean, ping860: boolean, ping861: boolean, ping862: boolean, ping863: boolean, ping864: boolean, ping865: boolean, ping866: boolean, ping867: boolean, ping868: boolean, ping869: boolean, ping870: boolean, ping871: boolean, ping872: boolean, ping873: boolean, ping874: boolean, ping875: boolean, ping876: boolean, ping877: boolean, ping878: boolean, ping879: boolean, ping880: boolean, ping881: boolean, ping882: boolean, ping883: boolean, ping884: boolean, ping885: boolean, ping886: boolean, ping887: boolean, ping888: boolean, ping889: boolean, ping890: boolean, ping891: boolean, ping892: boolean, ping893: boolean, ping894: boolean, ping895: boolean, ping896: boolean, ping897: boolean, ping898: boolean, ping899: boolean, ping900: boolean, ping901: boolean, ping902: boolean, ping903: boolean, ping904: boolean, ping905: boolean, ping906: boolean, ping907: boolean, ping908: boolean, ping909: boolean, ping910: boolean, ping911: boolean, ping912: boolean, ping913: boolean, ping914: boolean, ping915: boolean, ping916: boolean, ping917: boolean, ping918: boolean, ping919: boolean, ping920: boolean, ping921: boolean, ping922: boolean, ping923: boolean, ping924: boolean, ping925: boolean, ping926: boolean, ping927: boolean, ping928: boolean, ping929: boolean, ping930: boolean, ping931: boolean, ping932: boolean, ping933: boolean, ping934: boolean, ping935: boolean, ping936: boolean, ping937: boolean, ping938: boolean, ping939: boolean, ping940: boolean, ping941: boolean, ping942: boolean, ping943: boolean, ping944: boolean, ping945: boolean, ping946: boolean, ping947: boolean, ping948: boolean, ping949: boolean, ping950: boolean, ping951: boolean, ping952: boolean, ping953: boolean, ping954: boolean, ping955: boolean, ping956: boolean, ping957: boolean, ping958: boolean, ping959: boolean, ping960: boolean, ping961: boolean, ping962: boolean, ping963: boolean, ping964: boolean, ping965: boolean, ping966: boolean, ping967: boolean, ping968: boolean, ping969: boolean, ping970: boolean, ping971: boolean, ping972: boolean, ping973: boolean, ping974: boolean, ping975: boolean, ping976: boolean, ping977: boolean, ping978: boolean, ping979: boolean, ping980: boolean, ping981: boolean, ping982: boolean, ping983: boolean, ping984: boolean, ping985: boolean, ping986: boolean, ping987: boolean, ping988: boolean, ping989: boolean, ping990: boolean, ping991: boolean, ping992: boolean, ping993: boolean, ping994: boolean, ping995: boolean, ping996: boolean, ping997: boolean, ping998: boolean, ping999: boolean };


export type JampotFetchOptions = {
  headers?: Headers,
}

export type RegionPageQueryVariables = Flgsouv4dx19z4lxe91b2aizQueryVariables;
export type FleamarketArticlePageQueryVariables = Fripvga37v2mua02gbe8uqynQueryVariables;
export type UserPageQueryVariables = Hik5n3ms1203n6p6qpzlqbbbQueryVariables;
export type HomePageQueryVariables = Oo30o3ofrqgxsncrdx3tl68fQueryVariables;
export type AllPageQueryVariables = Erp990xduvwiox2vph5gyi6fQueryVariables;
export type CategoriesPageQueryVariables = R94ptrht725sh7n5v7scbcrgQueryVariables;
export type PingPageQueryVariables = Jn3y9o4zsfq2npf6tcmfa3qnQueryVariables;

export type Jampot = {
  fetch(
      urlPattern: "/:c/regions/(:name-):id(/)",
      variables: Flgsouv4dx19z4lxe91b2aizQueryVariables & { c: string; id: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Flgsouv4dx19z4lxe91b2aizQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell/(:title-):nodeId(/)",
      variables: Fripvga37v2mua02gbe8uqynQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Fripvga37v2mua02gbe8uqynQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/users/(:nickname-):nodeId(/)",
      variables: Hik5n3ms1203n6p6qpzlqbbbQueryVariables & { c: string; nodeId: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Hik5n3ms1203n6p6qpzlqbbbQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c(/)",
      variables: Oo30o3ofrqgxsncrdx3tl68fQueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Oo30o3ofrqgxsncrdx3tl68fQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell/all(/)",
      variables: Erp990xduvwiox2vph5gyi6fQueryVariables & { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Erp990xduvwiox2vph5gyi6fQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/:c/buy-sell/categories(/)",
      variables: { c: string; },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: R94ptrht725sh7n5v7scbcrgQuery, extensions?: any } | null>;
  fetch(
      urlPattern: "/ping",
      variables: {  },
      fetchOptions?: JampotFetchOptions
    ): Promise<{ data: Jn3y9o4zsfq2npf6tcmfa3qnQuery, extensions?: any } | null>;
};

const queryHashes: {
  [urlPattern: string]: string | undefined
} = {
    ["/:c/regions/(:name-):id(/)"]: "5970e1bec0366e2e59ec9e7a307085f3",
    ["/:c/buy-sell/(:title-):nodeId(/)"]: "f380c87a2dffeaf37acc992209182356",
    ["/:c/users/(:nickname-):nodeId(/)"]: "7a63279481abd2b9fb400bd64d785101",
    ["/:c(/)"]: "6af50dbbbe238a4ee20954f85801d612",
    ["/:c/buy-sell/all(/)"]: "a0d40d903ed914b605978ff6e1bdf97a",
    ["/:c/buy-sell/categories(/)"]: "9472bc92188a6d82db52212e35af997d",
    ["/ping"]: "985660bcd5721ccce428dff77dec4802",
};

function pathToUrl(path: string) {
  return new URL(path, "file://");
}

function urlSearchParamsToMap(urlSearchParams: URLSearchParams) {
  const map: { [key: string]: any } = {};

  urlSearchParams.forEach((value, key) => {
    map[key] = value;
  });

  return map;
}

function appendTrailingSlashInPathname(pathname: string) {
  if (pathname.endsWith("/")) {
    return pathname;
  }
  return `${pathname}/`;
}

function prependQuestionMarkInSearchParams(searchParams: URLSearchParams) {
  const searchParamsStr = searchParams.toString();

  if (searchParamsStr.length > 0) {
    return `?${searchParams}`;
  }
  return searchParams;
}

/**
 * import { UrlPatternOptions } from "url-pattern"
 */
export interface UrlPatternOptions {
  escapeChar?: string;
  segmentNameStartChar?: string;
  segmentValueCharset?: string;
  segmentNameCharset?: string;
  optionalSegmentStartChar?: string;
  optionalSegmentEndChar?: string;
  wildcardChar?: string;
}

export function makeTemplate(
  templateStr: string,
  urlPatternOptions?: UrlPatternOptions,
) {
  const pattern = new UrlPattern(`${templateStr}(/)`, urlPatternOptions);

  return {
    fill(params: { [key: string]: string | undefined }): string | null {
      const pathname = pattern.stringify(params);
      const pathParams = pattern.match(pathname);

      const searchParamsMap = { ...params };

      if (!pathParams) {
        return null;
      }

      Object.keys(pathParams).forEach((key) => {
        delete searchParamsMap[key];
      });

      const searchParams = new URLSearchParams(
        Object.entries(searchParamsMap).reduce(
          (acc, [key, value]) => ({
            ...acc,
            ...(value
              ? {
                  [key]: value,
                }
              : null),
          }),
          {} as Record<string, string>,
        ),
      );

      return (
        appendTrailingSlashInPathname(pathname) +
        prependQuestionMarkInSearchParams(searchParams)
      );
    },
    parse<T extends { [key: string]: string | undefined }>(
      path: string,
    ): T | null {
      const url = pathToUrl(path);
      const pathParams = pattern.match(url.pathname);
      const searchParams = urlSearchParamsToMap(url.searchParams);

      if (!pathParams) {
        return null;
      }

      return {
        ...searchParams,
        ...pathParams,
      };
    },
  };
}

export function jampot(options?: { fetch?: any }): Jampot {
  return {
    async fetch(urlPattern: string, variables: any, fetchOptions?: any): Promise<any> {
      const queryHash = queryHashes[urlPattern];

      const template = makeTemplate(urlPattern);
      const url = template.fill({
        ...variables,
        h: queryHash,
      });

      if (!url) {
        return null;
      }

      const f = options?.fetch ?? globalThis.fetch;

      return f(url, { headers: fetchOptions?.headers });
    },
  };
}